import type { ApolloError } from '@apollo/client';

export const graphQLErrorsOf = (error: unknown) =>
  (error as ApolloError | undefined)?.graphQLErrors ?? [];

/**
 * > An active model change proposal already exists for this entity. Complete or
 * > cancel it before starting a new one.
 */
const ACTIVE_PROPOSAL_MESSAGE = /active model change proposal already exists/i;

/**
 * The refusal product-service gives when a household's own copy of a model is
 * asked to be swapped or archived while a change against it is out for
 * signature.
 *
 * The code it comes with, `NOT_ACCESSIBLE`, is the one every refusal from the
 * service carries, so the message is what narrows it to this one. A refusal
 * that reaches us without extensions is matched on the message alone rather
 * than being reported to the advisor as a plain failure.
 */
export const isModelChangeProposalInFlight = (error: unknown): boolean =>
  graphQLErrorsOf(error).some((graphQLError) => {
    const code = graphQLError.extensions?.code;
    return (
      (code === undefined || code === 'NOT_ACCESSIBLE') &&
      ACTIVE_PROPOSAL_MESSAGE.test(graphQLError.message)
    );
  });
